import React from 'react';

import { toTelemetryContext } from '../../core/logs';
import { PaymentWidgetProps } from '../../types';
import { ErrorBoundary } from '../common';
import { PaymentMethodManager } from '../payment-method-manager';

export const PaymentWidget: React.FC<PaymentWidgetProps> = ({
    config,
    paymentProcessor
}) => {
    return (
        <ErrorBoundary telemetryContext={toTelemetryContext(config)}>
            <PaymentMethodManager paymentProcessor={paymentProcessor} />
        </ErrorBoundary>
    );
};
